import type { FC } from "react";
import { Banner, Icon } from "../../primitives";

export type ProcessingBannerProps = {
	testId: string;
	title: string;
	description: string;
};

/** Background-processing notice, sized to sit inside an overview tab rather than head the page. */
export const ProcessingBanner: FC<ProcessingBannerProps> = ({ testId, title, description }) => (
	<Banner
		data-testid={testId}
		className="gap-x-[10px] rounded-lg border-bc-strong bg-surface-light"
	>
		<Banner.Leading>
			<Icon type="hourglass" color="tertiary" size="small" />
		</Banner.Leading>
		<Banner.Content>
			<div className="text-[13px] font-[550] text-primary">{title}</div>
			<div className="text-[12px] text-tertiary">{description}</div>
		</Banner.Content>
	</Banner>
);
